import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { LOADING_ICON } from "../icons.js";
export default function IconButton(props) {
    const { busy, disabled, children, icon, ...rest } = props;
    return (_jsxs(Button, { ...rest, disabled: (busy ?? false) || (disabled ?? false), children: [_jsx(FontAwesomeIcon, { ...busy ? LOADING_ICON : icon, spin: busy }), _jsx("span", { className: "icon-left" }), children] }));
}
